import { APP_INITIALIZER, ModuleWithProviders, NgModule } from '@angular/core';
import { PrivacyService } from '@df/module-privacy/privacy.service';

@NgModule()
export class DfModulePrivacyModule {
    static forRoot(): ModuleWithProviders<DfModulePrivacyModule> {
        return {
            ngModule: DfModulePrivacyModule,
            providers: [
                {
                    provide: APP_INITIALIZER,
                    useFactory: (privacyService: PrivacyService) => () => privacyService.appInitialize(),
                    deps: [PrivacyService],
                    multi: true
                }
            ]
        };
    }
}
